import React, { useState } from 'react'
import "./SelectDropdown.css"
import monthsDOB from '../StateObjects/Months';

const SelectDropdown = ({ label, infoKey = "", name, value, dropdown, dobField = false, dobValues, hhmSet = false, setCallback }) => {
    var minimumDriverYear = new Date().getFullYear() - 16

    return (
        <div className='row my-3 d-flex justify-content-start'>
            <div className='col-12 col-sm-6 col-md-6'>
                <p className='text-primary fw-bold field'>
                    {label}
                </p>
            </div>

            {!dobField &&
                <div className='col-12 col-sm-6 col-md-6 selectValue'>
                    <div className="btn-group custom-selector col-12">
                        <select name={`${infoKey ? infoKey + "_" : ""}${name}`} className='btn btn-default btn-group dropdown-toggle filter-option dropdownSize fs-6'
                            value={value}
                            onChange={(e) => setCallback(name, e.target.value, infoKey)}
                        >
                            {dropdown.map((value, index) => {
                                return (
                                    <option className='fs-6' value={value} key={index}>{value}</option>
                                )
                            })}
                        </select>
                    </div>
                </div>
            }

            {dobField &&
                <div className='col-12 row'>
                    {["Month", "Day", "Year"].map((field, id) => {
                        var fieldName = "dob" + field;

                        return (
                            <div key={id} className="col-4 col-sm-4 col-md-3 col-xl-3 selectDobFields">
                                <div className="btn-group bootstrap-select custom-selector">
                                    <select className="btn btn-default btn-group dropdown-toggle filter-option dropdownSize fs-6"
                                        name={`${infoKey ? infoKey + "_" : ""}dob${field}`}
                                        value={dobValues[fieldName]}
                                        onChange={(e) => setCallback(`dob${field}`, e.target.value, infoKey)}
                                    >
                                        <option>{field}</option>
                                        {/* Months */}
                                        {field === "Month" && monthsDOB.map((month, index) => (
                                            <option className='fs-6' key={index} value={month}>
                                                {month}
                                            </option>
                                        ))}
                                        {/* Days */}
                                        {field === 'Day' && (
                                            [...Array(31)].map((_, index) => {
                                                const day = index + 1;
                                                return (
                                                    <option className='fs-6' key={day} value={day}>
                                                        {day}
                                                    </option>
                                                );
                                            })
                                        )}
                                        {/* Year starts at 1900 */}
                                        {field === "Year" && (
                                            [...Array(minimumDriverYear - 1900 + 1)].map((_, index) => {
                                                const year = hhmSet ? new Date().getFullYear() - index : minimumDriverYear - index;
                                                return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                );
                                            })
                                        )}
                                    </select>
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
        </div>
    )
}

export default SelectDropdown